export default __webpack_public_path__ + "static/media/A01.ad21f031.png";